import { getAppVersion } from "../version";

export interface DeviceInfo {
  api_level: string;
  mac_address: string;
  is_emulator: boolean;
  device_name: string;
  device_id: string;
  device_country: string;
  device_locale: string;
  device_carrier: string;
  device_build_number: string;
  brand: string;
  is_tablet: boolean;
  os_version: string;
  app_version: string;
  os: "Android" | "iOS" | "Web";
  country: string;
  is_pin_set: boolean;
  device_brand: string;
  unique_id: string;
}

export const DEVICE_INFO_DEFAULTS: Omit<DeviceInfo, "unique_id"> = {
  api_level: "1.0.0",
  mac_address: "00:00:00:00:00:00",
  is_emulator: false,
  device_name: "Unknown",
  device_id: "WEB",
  device_country: "IR",
  device_locale: "fa-IR",
  device_carrier: "",
  device_build_number: "PWA",
  brand: "",
  is_tablet: false,
  os_version: "",
  app_version: getAppVersion().version,
  os: "Web",
  country: "IR",
  is_pin_set: false,
  device_brand: "",
};
